import { Characteristic } from '../schema-types/schemaTypes';

export const getCharacteristicValue = (
  characteristics: Characteristic[],
  name: string
): string | null =>
  characteristics.find(
    (characteristic: Characteristic) => characteristic?.name === name
  )?.value ?? null;
